const EARTH_RADIUS_MILES = 3958.8; // Radius of the Earth in miles
export const METERS_PER_MILE = 1609.34;

const toRadians = (degree: number): number => (degree * Math.PI) / 180;

interface LocationPoint {
  lat: number;
  lng: number;
}

export const haversineDistance = (
  startPoint: LocationPoint,
  endPoint: LocationPoint,
): number => {
  const dLat = toRadians(endPoint.lat - startPoint.lat);
  const dLon = toRadians(endPoint.lng - startPoint.lng);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(startPoint.lat)) *
      Math.cos(toRadians(endPoint.lat)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return EARTH_RADIUS_MILES * c;
};

export const milesToMeters = (miles: number): number =>
  Math.round(miles * METERS_PER_MILE);
